export default function currency (amount) {
	return (amount ?? 0)
		.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })
		.replace('.00', '');
}
